document.addEventListener('DOMContentLoaded', function () {
  var lang = document.documentElement.getAttribute('lang');
  if (!lang || lang === 'en') return;
  var prefix = '/' + lang;
  var skip = ['/cdn', '/checkout', '/cart', '/admin', '/apps', '/services', '/community_theme_editor'];
  document.querySelectorAll('a[href^="/"]').forEach(function (a) {
    var href = a.getAttribute('href');
    if (!href || href === prefix || href.indexOf(prefix + '/') === 0) return;
    if (skip.some(function (p) { return href === p || href.indexOf(p + '/') === 0; })) return;
    a.setAttribute('href', prefix + href);
  });
});
